module.exports = "pegasus/assets/preview-21.png";